'use client'

import { useEffect, useRef, useState } from 'react'

/**
 * True only after the component has mounted on the client.
 * Use to gate window/localStorage/Capacitor/time-based render output.
 */
export function useClientMounted(componentName?: string): boolean {
  const [mounted, setMounted] = useState(false)
  const tracedRef = useRef(false)

  useEffect(() => {
    if (componentName && !tracedRef.current) {
      console.log(
        `[HydrationTrace] ${componentName} client mount ${JSON.stringify({
          href: typeof window !== 'undefined' ? window.location.pathname : null,
        })}`
      )
      tracedRef.current = true
    }
    setMounted(true)
  }, [componentName])

  return mounted
}

export function logHydrationFirstRender(
  componentName: string,
  values: Record<string, unknown>
): void {
  console.log(
    `[HydrationTrace] ${componentName} render ${JSON.stringify(values)}`
  )
}
